// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-slip[data-v-3ce2fc93] {\n  width: 80%;\n  height: 150px;\n  background: #F9F9F9;\n  border: 1px dashed #E4E4E4;\n  border-radius: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
